import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';

import { useSelector } from 'react-redux';
import {
  getTicketCouponsSelector,
  getTicketCouponsPriceSelector
} from '../../../../store/ticket';
import { getMealSelector } from '../../../../store/meal';
import {
  getEatingSelector,
  getEatingByNameSelector
} from '../../../../store/eating';
import _ from 'lodash';

const useStyles = makeStyles(theme => ({
  nestedHead: {
    // paddingLeft: theme.spacing(4),
  },
  nested: {
    // paddingLeft: theme.spacing(6),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText: {
    fontSize: 13
  }
}));

const SelectedMeal = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const coupons = useSelector(getTicketCouponsSelector);
  const couponsPrice = useSelector(getTicketCouponsPriceSelector);
  const mealData = useSelector(getMealSelector);
  const eating = useSelector(getEatingSelector);

  // console.log('coupons', coupons);

  const [dishes, setDishes] = useState([]);
  // console.log('dishes',dishes);

  useEffect(() => {
    if (coupons.length > 0) {
      // if(eventeatings.meals && eventeatings.meals.length > 0){

      // const chosenDishes = addCouponToDishes(mealData.filter(m => eventeatings.meals.includes(m.id)), coupons)
      setDishes(
        coupons
          .map(coupon => {
            return {
              ...coupon,
              eating: eating.filter(e => e.id === coupon.eatingId)[0],
              meal: mealData.filter(m => m.id === coupon.mealId)[0]
            };
          })
          .filter(c => c.amount > 0)
      );
      // }
    }
  }, [coupons]);

  // console.log('coupons',coupons);

  return (
    <Card>
      <CardHeader
        // title={` . Сумма: ${dishes.reduce((acc,d)=>{ return acc + d.price * d.amount},0 )} ฿`}
        title={`Сумма: ${couponsPrice} ฿`}
      />
      <Divider />
      <CardContent>
        {coupons.length > 0 && (
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead style={{ backgroundColor: 'white' }}>
                <TableRow>
                  <TableCell>Дата</TableCell>
                  <TableCell>Время</TableCell>
                  <TableCell>Цена</TableCell>
                  <TableCell>Название</TableCell>
                  <TableCell>Кол-во</TableCell>
                  <TableCell>Итого</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dishes.length > 0 &&
                  _.sortBy(dishes, ['date', 'eating.name']).map(d => (
                    <TableRow
                      key={`${d.eventeatingId}_${d.mealId}_${d.meetingId}`}>
                      <TableCell>{d.date}</TableCell>
                      <TableCell>{d.eating.name}</TableCell>
                      <TableCell>{d.price} ฿</TableCell>
                      <TableCell>{d.meal.name}</TableCell>
                      <TableCell>{d.amount}</TableCell>
                      <TableCell>{d.amount * d.price} ฿</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default SelectedMeal;
